import { render, staticRenderFns } from "./tasks-analytics-view.vue?vue&type=template&id=ffdc48be&scoped=true"
import script from "./tasks-analytics-view.vue?vue&type=script&lang=js"
export * from "./tasks-analytics-view.vue?vue&type=script&lang=js"
import style0 from "./tasks-analytics-view.vue?vue&type=style&index=0&id=ffdc48be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdc48be",
  null
  
)

export default component.exports